module.exports = __webpack_public_path__ + "static/media/learning.19a61073.png";